import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapActions, mapMutations } from 'vuex';

import * as accountType from '@account/store/types'
import * as dateutil from '@appbase/util/date-helper';
import VueAES from '@/modules/@appbase/util/vue-aes'


@Component({
    name: 'RedirectPage',
    components: { },
    computed: mapGetters({
        current: accountType.CURRENT
    }),
    methods: {
        ...mapActions({
        }),
        ...mapMutations({
        }),
    },
})
export default class RedirectPage extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //  
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //   

    current!:account.TCurrent

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    mounted() {
        let moveTo = 'http://ehr.cj.net/eHR/frameone/syscommon/healthCareAuthority/ssoauth2.fo';
        var date = dateutil.uGetDateFormat('yyyyMMDDHis',new Date())
        var token = `timestamp=${date}&comCode=${this.current.user.comCode}&personCode=${this.current.user.personId}&cefcjSsoId=${this.current.user.cjId!=''?this.current.user.cjId:'none'}`
        var aes = new VueAES(this.current.key)
        moveTo += `?toke=${encodeURIComponent(aes.encrypt(token))}&page=HR555&languageCd=KOR`;

        window.location.href = moveTo;
    }

    created() {

    }
}
